import React, {useEffect, useCallback} from 'react';
import {useHistory, withRouter} from 'react-router-dom';
import {connect} from 'react-redux';

import Filter from '@ey/canvascoreservices/Filters';

import {labels} from '../../../../../util/utils';
import Utility from '../../../../../util/utilityfunctions';
import {ContactsDBFilterTypeQuery} from '../../../../../util/uiconstants';
import {ContactsDBFilterEntityConfiguration} from '../../../../Common/Filter/config';

import * as FilterContacts from '../../../../../actions/ContactDB';
import * as ErrorActions from '../../../../../actions/erroractions';
import * as FilterActions from '../../../../../actions/Filter/FilterActions';
import * as ContactDBFilterActions from '../../../../../actions/ContactDB/ContactDBFilterActions';

export const ContactsDBFilters = ({actions, filterConfiguration, state, dispatch, _syncQueryString}) => {
	const history = useHistory();

	useEffect(() => {
		if (filterConfiguration.state) {
			Object.values(state.filters).forEach((filter) => {
				if (filter.name.indexOf('|') > -1 && filter.value.length > 0) {
					actions.getFilterEntities(
						filterConfiguration.key,
						filter.entityType + '|' + filter.entity.value,
						filter.entityType,
						filter.entityFilter,
						ContactsDBFilterEntityConfiguration[filter.entityType].entityMapping
					);
				}
			});
		}

		SetSelectedFilterByQS(filterConfiguration, actions);
	}, []);

	const appliedFiltersAmount = (filters, appliesCurrentFilter = false) => {
		if (filters) {
			const contactsbycountry = filters.contactsbycountry?.value?.length || 0;
			const contactsbygrouprole = filters.contactsbygrouprole?.value?.length || 0;
			const contactsbyengagement = filters.contactsbyengagement?.value?.length || 0;
			const type = filters.type?.value?.length || 0;
			const contactsbyserviceline = filters.contactsbyserviceline?.value?.length || 0;
			const contactsbyrole = filters.contactsbyrole?.value?.length || 0;
			const dashboardaccess = filters.dashboardaccess?.type === 'boolean' ? 1 : 0;
			const groupAccess = filters.groupAccess?.type === 'boolean' ? 1 : 0;
			const contactlist = filters.contactlist?.type === 'boolean' ? 1 : 0;
			const contactsbytag = filters.contactsbytag?.value?.length || 0;

			const currentFilter = appliesCurrentFilter ? 1 : 0;

			return (
				contactsbycountry +
				contactsbygrouprole +
				contactsbyengagement +
				type +
				contactsbyserviceline +
				contactsbyrole +
				dashboardaccess +
				groupAccess +
				contactlist +
				currentFilter +
				contactsbytag
			);
		}
	};

	const handleSetState = useCallback(
		(filters) => {
			const appliedFilters = appliedFiltersAmount(filters);

			// Avoid adding exceeded filters to filter state.
			if (appliedFilters > 25) {
				return;
			}

			dispatch({
				type: 'state/set',
				value: {
					filters
				}
			});
		},
		[dispatch]
	);

	const handleOnSetFilter = useCallback(
		(filter, value) => {
			const appliedFilters = appliedFiltersAmount(filter.state, true);

			// No more than 25 filters can be applied.
			if (appliedFilters > 25) {
				actions.displayError(labels.filtersWarningMessage);
				return;
			}

			actions.setContactDBFilter(filter.name, value);
			actions.setContacts({name: filter.name, value: value});
		},
		[actions]
	);

	return (
		<Filter
			syncQueryString
			_syncQueryString={_syncQueryString}
			history={history}
			searchPlaceholder={labels.placeholderForSearch}
			filterKey={filterConfiguration.key}
			filters={filterConfiguration}
			state={state.filters}
			setState={handleSetState}
			onEnableFilter={handleOnSetFilter}
			onDisableFilter={handleOnSetFilter}
			labelYes={labels.filterYes}
			labelNo={labels.filterNo}
			clearHoverText={labels.clearHoverText}
			noFiltersAvailableLabel={labels.noFiltersAvailable}
			noResultsPlaceholder={labels.noResultsAvailable}
			tooltip={labels.filterTooltip}
			theme={Utility.getMotifTheme()}
			searchButtonTitle={labels.search}
		/>
	);
};

const mapStateToProps = (store) => {
	return {
		projectId: store.project.projectId,
		contactDBFilters: store.contactDBFilters
	};
};

const mapDispatchToProps = (dispatch) => ({
	actions: {
		setContactDBFilter: (filterItemName, value) =>
			dispatch(ContactDBFilterActions.setContactDBFilter(filterItemName, value)),

		setContacts: (filter) => dispatch(FilterContacts.filterContacts({filters: filter})),

		getFilterEntities: (key, name, entityType, entityFilter, dataMapping) =>
			dispatch(FilterActions.getFilterEntities(key, name, entityType, entityFilter, dataMapping)),

		displayError: (message) => dispatch(ErrorActions.raiseJSValidationError(message))
	}
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ContactsDBFilters));

function SetSelectedFilterByQS(filterConfiguration, actions) {
	if (!_.isEmpty(filterConfiguration.queryString)) {
		if (filterConfiguration.queryString.contactsbycountry?.length > 0) {
			actions.setContactDBFilter(ContactsDBFilterTypeQuery.byCountry, [
				...filterConfiguration.queryString.contactsbycountry
			]);
			actions.setContacts({
				name: ContactsDBFilterTypeQuery.byCountry,
				value: [...filterConfiguration.queryString.contactsbycountry]
			});
		}

		if (filterConfiguration.queryString.contactsbygrouprole?.length > 0) {
			actions.setContactDBFilter(ContactsDBFilterTypeQuery.byGroupRole, [
				...filterConfiguration.queryString.contactsbygrouprole
			]);
			actions.setContacts({
				name: ContactsDBFilterTypeQuery.byGroupRole,
				value: [...filterConfiguration.queryString.contactsbygrouprole]
			});
		}

		if (filterConfiguration.queryString.contactsbyengagement?.length > 0) {
			actions.setContactDBFilter(ContactsDBFilterTypeQuery.byEngagement, [
				...filterConfiguration.queryString.contactsbyengagement
			]);
			actions.setContacts({
				name: ContactsDBFilterTypeQuery.byEngagement,
				value: [...filterConfiguration.queryString.contactsbyengagement]
			});
		}

		if (filterConfiguration.queryString.type?.length > 0) {
			actions.setContactDBFilter(ContactsDBFilterTypeQuery.byType, [...filterConfiguration.queryString.type]);
			actions.setContacts({name: ContactsDBFilterTypeQuery.byType, value: [...filterConfiguration.queryString.type]});
		}

		if (filterConfiguration.queryString.contactsbyserviceline?.length > 0) {
			actions.setContactDBFilter(ContactsDBFilterTypeQuery.byServiceLine, [
				...filterConfiguration.queryString.contactsbyserviceline
			]);
			actions.setContacts({
				name: ContactsDBFilterTypeQuery.byServiceLine,
				value: [...filterConfiguration.queryString.contactsbyserviceline]
			});
		}

		if (filterConfiguration.queryString.contactsbyrole?.length > 0) {
			actions.setContactDBFilter(ContactsDBFilterTypeQuery.byRole, [...filterConfiguration.queryString.contactsbyrole]);
			actions.setContacts({
				name: ContactsDBFilterTypeQuery.byRole,
				value: [...filterConfiguration.queryString.contactsbyrole]
			});
		}

		if (filterConfiguration.queryString.contactsbytag?.length > 0) {
			actions.setContactDBFilter(ContactsDBFilterTypeQuery.byTag, [...filterConfiguration.queryString.contactsbytag]);
			actions.setContacts({
				name: ContactsDBFilterTypeQuery.byTag,
				value: [...filterConfiguration.queryString.contactsbytag]
			});
		}

		if (typeof filterConfiguration.queryString.contactlist === 'boolean') {
			actions.setContactDBFilter(ContactsDBFilterTypeQuery.byContactList, filterConfiguration.queryString.contactlist);
			actions.setContacts({
				name: ContactsDBFilterTypeQuery.byContactList,
				value: filterConfiguration.queryString.contactlist
			});
		}

		if (typeof filterConfiguration.queryString.dashboardaccess === 'boolean') {
			actions.setContactDBFilter(
				ContactsDBFilterTypeQuery.byDashboardAccess,
				filterConfiguration.queryString.dashboardaccess
			);
			actions.setContacts({
				name: ContactsDBFilterTypeQuery.byDashboardAccess,
				value: filterConfiguration.queryString.dashboardaccess
			});
		}

		if (typeof filterConfiguration.queryString.groupAccess === 'boolean') {
			actions.setContactDBFilter(ContactsDBFilterTypeQuery.byGroupAccess, filterConfiguration.queryString.graAccess);
			actions.setContacts({
				name: ContactsDBFilterTypeQuery.byGroupAccess,
				value: filterConfiguration.queryString.groupaccess
			});
		}
	}
}
